import React from "react";
import finvu2 from "../images/finvu2.svg";
import rarrow from "../images/right_arrow.png";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: true });

export default function Proceed() {
  const navigate = useNavigate();
  const handleClick = (e) => {
    mixpanel.track("Interacted_BS_Process_Pop_Up", {
      "Clicked on": "Proceed",
      Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
      user_type:localStorage.getItem('user_type')
    });
    e.preventDefault();
    document.getElementById("root").style.backgroundColor = "rgba(0, 0, 0,0)";
    navigate("/verifyotp");

  };
  return (
    <div className="process">
      <div className="content">
        <h1>How it works?</h1>
        <p>
          You need to provide your account information on Finvu inorder to
          verify your bank statement
        </p>
      </div>
      <div className="steps">
        <span>Steps :</span>
        <p>
          {" "}
          <img src={rarrow}></img>{" "}
          <span>Mobile OTP verification sent by Finvu</span>
        </p>
        <p>
          {" "}
          <img src={rarrow}></img>
          <span> Select your bank accounts </span>
        </p>
        <p>
          <img src={rarrow} /> <span>Verify your accounts via OTP</span>{" "}
        </p>
        <p>
          <img src={rarrow} />{" "}
          <span>Track your bank transactions seamlessly</span>
        </p>
      </div>

      <div className="regulation">
        <p>Powered by RBI regulated Account Aggregator:</p>
        <img src={finvu2}></img>
      </div>

      <div className="proceed">
        <button onClick={ (e) => {handleClick(e)}}>Proceed</button>
      </div>
    </div>
  );
}
